"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faPlus = require("@fortawesome/pro-regular-svg-icons/faPlus");

var _peractoEditorUi = require("@peracto/peracto-editor-ui");

var _AccountNumberRestrictionsList = _interopRequireDefault(require("./AccountNumberRestrictionsList"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var AccountNumberRestrictions = function AccountNumberRestrictions(_ref) {
  var settings = _ref.settings,
      setSettings = _ref.setSettings;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      accountNumber = _useState2[0],
      setAccountNumber = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "related-products-section"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "mt-2"
  }, "Main Account Number Restrictions"), /*#__PURE__*/_react["default"].createElement(_AccountNumberRestrictionsList["default"], {
    settings: settings,
    setSettings: setSettings
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "account-number-restriction",
    className: "d-flex flex-row items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow"
  }, /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.TextInput, {
    placeholder: 'Main Account Number',
    "data-testid": 'input-account-number',
    value: accountNumber,
    onChange: function onChange(e) {
      setAccountNumber(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 13
      /* Enter */
      ) {
        if ((accountNumber === null || accountNumber === void 0 ? void 0 : accountNumber.length) > 0) {
          setSettings(_objectSpread(_objectSpread({}, settings), {}, {
            contentBabbageAccountRestriction: [].concat(_toConsumableArray(settings.contentBabbageAccountRestriction), [{
              babbageAccount: accountNumber
            }])
          }));
          setAccountNumber('');
        }
      }
    },
    wrapperClassName: "mb-0",
    className: "mb-0"
  })), /*#__PURE__*/_react["default"].createElement("button", {
    title: "Add",
    className: "btn btn-success ml-2",
    "data-testid": "content-add",
    disabled: (accountNumber === null || accountNumber === void 0 ? void 0 : accountNumber.length) === 0,
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();

      if ((accountNumber === null || accountNumber === void 0 ? void 0 : accountNumber.length) > 0) {
        setSettings(_objectSpread(_objectSpread({}, settings), {}, {
          contentBabbageAccountRestriction: [].concat(_toConsumableArray(settings.contentBabbageAccountRestriction), [{
            babbageAccount: accountNumber
          }])
        }));
        setAccountNumber('');
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faPlus.faPlus
  }))));
};

var _default = AccountNumberRestrictions;
exports["default"] = _default;